var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"embed_video"}},[(_vm.podcast && _vm.podcastFound)?_c('iframe',{attrs:{"allow":"autoplay","id":"iframe_player","scrolling":"no","src":_vm.podcast.link,"frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":"","width":"100%","height":"100%"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c37bbf06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmbedPodcast.vue
// module id = null
// module chunks = 